exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".theme-ccb .no-result-index .text[data-v-242fb7e0]{color:#09b6f2}.no-result-index[data-v-242fb7e0]{line-height:.19rem;padding:.3rem 0;background-color:#fff;text-align:center;color:#999}.no-result-index .text[data-v-242fb7e0]{padding-top:.05rem;font-size:.14rem;color:var(--color-theme,#f9ac19);text-decoration:underline}.no-result-index .title[data-v-242fb7e0]{font-size:.14rem}.no-result-index.font36 .text[data-v-242fb7e0],.no-result-index.font36 .title[data-v-242fb7e0]{font-size:.18rem;line-height:.25rem}", ""]);

// exports
